import React, { useState, useRef, useEffect, useCallback } from "react";
import { createContext, ReactElement, useContext } from "react";
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Box, Button, Typography, Chip, Alert, Collapse, AlertTitle, IconButton } from '@mui/material';
import { NavBar1 } from './components/navbar/NavBar1';
import { Map } from './components/map/Map';
import { Disclaimer, DataDeletionInstructions } from './components/Disclaimer';
//import { LeftDrawer } from './components/LeftDrawer';
//import { Resources } from './components/resources/LinkGrid';
import Grid from '@mui/material/Grid';
import { MapBars } from './components/map/MapBars'
import { MapPinCount } from './components/map/MapPinCount'
//import { Authenticator, useAuthenticator } from "react-oidc-context";
import { CircularProgress } from "@mui/material";
import { setSearch, setZoom } from './features/searchSlice'
import { getDisclaimerCookie, isErrorStatus, isHttpOrNetworkError, loadImage, printError, setDisclaimerCookie, toStringRepresentation } from './app/utils'
import { getUserAttributes } from './features/userAttributesSlice'
import { ProfileWizard } from './components/profile/ProfileWizard'

import { AddPinChip } from './components/profile/AddPinChip'
import { /*showDisclaimer, showProfile, showSurvey, showDeleteAccount, showDataDeletionInstructions,  dialogSelector, showAuthProfile*/ showBanner } from "./features/dialogSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getVersion, useAuthProfile } from "./app/hooks"
import { useAuth } from 'react-oidc-context';
//import { setAuthToken } from "./app/authiutils";
import { CenterMapHome } from "./components/map/CenterMapHome";
//import { ChatMain } from "./components/messaging/ChatMain"
import { activateMarker } from "./features/activeMarkers"
//import {  useGetMessagingQuery } from './features/ChatSlice';

import { CircularProgressCentered } from "./app/components/sharedcomponents";
// BottomSheet replaced by MobileMapOverlay in MapOverlay
// import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet'
// import 'react-spring-bottom-sheet/dist/style.css'
import { useMediaQuery, useTheme } from "@mui/material";
import { AddBox, Add, Remove } from "@mui/icons-material";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { QueryStatus } from "@reduxjs/toolkit/query";
import { RootState } from './app/store';
import { Condition, coonditionContext } from "./index";
import { createSelector } from "@reduxjs/toolkit";
// import { LeftDrawer1 } from "./components/LeftDrawer1";
import { SkeletonWithRetry } from "./app/components/ProfileFetchError";
import { RightSideUIContext } from "./App";
import { ScienceOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { ChatScopeUseChatConversations } from "./components/messaging/ChatScopeUseChat";
// import { setBottomSheetState } from './features/utilitySlice';
import { PinInfoModal } from './components/markers/PinInfoModal';
//import { AuthProfileDialog } from "./components/iam/AuthProfileDisaply";
import { IsMobileContext } from './app/IsMobileContext';
import { MapOverlay } from './components/map/MapOverlay';

const bannerUrl = "/Resources?search=%24500+Remote+Research+Opportunity&category=Paid+Studies&status=Open&eligibility=Patients+diagnosed+with+bladder+cancer+Jan+1%2C+2016%2C+onward&studyType=Online+interview&compensation=%24500.+Receive+a+%2410+bonus+upon+sign+up+and+qualification.&contactId=44515&studyCtaUrl=https%3A%2F%2Fdocs.google.com%2Fforms%2Fd%2F1QfTuPpdH0fsR5-dxZnZhnQHm6hG3QBkvLNOdGDj9MNY%2Fviewform%3Fedit_requested%3Dtrue"
const bannerTitle = "Help Advance Bladder Cancer Research"
const bannerBBody = "This study aims to better understand the real‑world journey of people diagnosed with High‑Risk Non‑Muscle Invasive Bladder Cancer (HR‑NMIBC). Merck, Polygon Health, and BCAN are partnering to invite 100 eligible participants with HR-NMIBC to securely gather their health records through the Polygon Health Wallet and share a de‑identified version with Merck researchers. A $100 thank‑you gift for eligible participants."
const bannerCTAUrl = 'https://www.polygonhealth.co/bladdercancerstudy'


export const selectLastgetSearchByStoryStatusArgsAndData = createSelector(
  [(state: any) => state.aiAnalytics.queries],
  (queries) => {
    const getSearchByStoryEntries = Object.entries(queries).filter(
      ([key, query]: [string, any]) => key.startsWith('getSearchByStory')
    );

    if (getSearchByStoryEntries.length === 0) {
      return { status: undefined, args: undefined, data: undefined };
    }

    const [lastQueryKey, lastQueryValueRaw] = getSearchByStoryEntries[getSearchByStoryEntries.length - 1];

    const lastQueryValue = lastQueryValueRaw as {
      status: QueryStatus;
      data?: any;
    };

    // Extract args from cache key string
    const argsString = lastQueryKey.slice(
      lastQueryKey.indexOf('(') + 1,
      lastQueryKey.lastIndexOf(')')
    );

    const args = argsString ? JSON.parse(argsString) : undefined;

    return {
      status: lastQueryValue.status,
      args,
      data: lastQueryValue.data
    };
  }
);


const AppBody1: React.FC = () => {
  const searchState = useSelector((state: any) => state.search, (prev, next) => {
    if (!next.status) return true
    if (!next.status.isSuccess) return true
    if (!prev.center) return false
    return prev.formattedSearchTerm === next.formattedSearchTerm //&& ( prev.showProfileDialog === next.showProfileDialog  )
  });

  const { authStatus, profile, isLoading, isSuccess, isAuthenticated, authUser: user, error: errorAuthenticator, /*isSignOutErrorButLoggedIn,*/ isError: isProfileError, profileError } = useAuthProfile()

  const showDisclaimerState = useSelector((state: any) => state.dialog.showDisclaimer)
  const showProfileState = useSelector((state: any) => state.dialog.showProfile)
  // const showAuthProfileState = useSelector(dialogSelector).showAuthProfile
  
  const showSurveyState = useSelector((state: any) => state.dialog.showSurvey)
  const showDeleteAccountState = useSelector((state: any) => state.dialog.showDeleteAccount);
  const showProfileToComplete = profile ? profile.zipcode === null || profile.communicate_with_others === null || !profile.provide_information_for_research === null || !profile.receive_emails === null : false
  const isProfileVisible = (showProfileState || showProfileToComplete) && !showDeleteAccountState && authStatus === 'authenticated'
  const isSurveyVisible = (showSurveyState ? (!showSurveyState.isExited || showSurveyState.isForced || showSurveyState.isForcedFromSurvey) : false) && !showDeleteAccountState && authStatus === 'authenticated'
  const dispatch = useDispatch()
  const isDisclaimerCookie = getDisclaimerCookie()
  const { messages: ShowChatRightSideUI } = useContext(RightSideUIContext);
  const { showChat } = useSelector((state: any) => state.dialog.showDirectChat)
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  //const searchStoryState: any = useSelector<any>(state => state.search);
  //const lastgetSearchByStoryStatusArgsAndData = useSelector((state: any) => selectLastgetSearchByStoryStatusArgsAndData(state));
  const showBannerState = useSelector((state: any) => state.dialog.showBanner)
  //const openChannelReadyState = useSelector((state: any) => state.dialog.openChannelReady)
  const navigate = useNavigate();
  const { condition, baseName } = React.useContext<Condition>(coonditionContext);
  React.useEffect(() => {
    if (isSuccess) {
      //console.log(authStatus, profile.name_public)
      dispatch(setSearch({ lat: profile.lat, lng: profile.lng, formattedsearchterm: profile.formattedsearchterm }));
    }
  }, [profile])

  // Bladder Cancer used to force Phase III/IV trials (TR4,5) on here. Both phase bands
  // now default to off for every CT map (filterSlice), so this override is gone rather
  // than inverted — a dispatch to `false` would only re-assert what the default says.


  React.useEffect(() => {
    const timer1 = setTimeout(() => {
      dispatch(showBanner(false));
    }, 90000); // Auto-hide after 90 seconds
    return () => clearTimeout(timer1); // Cleanup timer on unmount
  }, []);


  //   const keyVialoation = profileErrorMsg && profileErrorMsg.includes("Key")
  //   if (keyVialoation) {
  //     logToBackEnd({ context: 'profileError-keyVialoation', message: toStringRepresentation({ ...profileError, sub: user?.profile?.sub ?? 'none' }, { status: 'ERROR' }), version: getVersion() });

  //     // return (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>
  //     //   <Box>
  //     //     {!keyVialoation && <Typography> Profile {profileError} </Typography>}
  //     //     {keyVialoation && <Typography> Invalid Profile:  remove profile before creating a new one
  //     //       <Button href={`/map/${baseName}/Sign-In`}>Login</Button></Typography>}
  //     //   </Box>
  //     // </div>)
  //   }
  // }
  const showDisclamer = !isDisclaimerCookie && showDisclaimerState && isSuccess && authStatus === 'unauthenticated' && !isLoading
  return (
    (ShowChatRightSideUI) ?
      (authStatus === 'unauthenticated') ? <ChatScopeUseChatConversations /> /*<ChatMain />*/ :
        // <Alert severity="error">Oops... Error occurred while initiating messaging feature.  Please try again later.</Alert>
        <Box id='App-Container'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: { xs: '100vh', sm: '100vh', md: '100vh' },
            width: '100vw',
            alignItems: 'center',
            justifyContent: 'center',
            //backgroundColor: 'blue'
          }}>
          <SkeletonWithRetry resourceLabel="your messages" />
        </Box>
      :
      <IsMobileContext.Provider value={isSmallScreen}>
      <>
        <Grid
          //padding={0}
          container
          //spacing={0}
          sx={{
            //overflow: 'auto',
            width: '100%',
            height: '100%',
            // flexGrow: 1,
            // backgroundColor:'red'
          }}
        >
          <Grid id="rightSide" sx={{
            width: '100%',
            height: '100%',
            position: 'relative',
          }}>
            {(condition === 'Bladder Cancer' && showBannerState) &&
              <Alert severity="info" icon={false} sx={{ position: 'absolute', zIndex: 1300, top: 10, left: 15, right: { xs: 15, sm: 110 }, backgroundColor: '#052D51', color: 'white', borderRadius: '10px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: '0px' }}>
                    <ScienceOutlined sx={{ marginRight: '10px', color: 'white' }} />
                    <Typography variant="subtitle2" >{bannerTitle}</Typography>
                  </Box>
                  <IconButton onClick={() => dispatch(showBanner(false))} sx={{ color: 'white' }}><CloseIcon /></IconButton>
                </Box>
                <Stack direction="row" sx={{ width: '100%', alignItems: "flex-end", flexWrap: { xs: 'wrap', sm: 'nowrap', md: 'nowrap', lg: 'nowrap' } }}>
                  <Typography variant="caption" >
                    {bannerBBody}
                  </Typography>
                  <Box sx={{ marginTop: { xs: '10px', sm: '0' }, marginLeft: { xs: '0', sm: '5px' }, flexShrink: 0, }}>
                    <Button variant="contained"  {...bannerCTAUrl ? { component: "a", href: bannerCTAUrl, target: "_blank", rel: "noopener noreferrer" } : { onClick: () => navigate(bannerUrl) }} sx={{ textTransform: 'none', flexShrink: 0, backgroundColor: 'white', color: '#052D51', borderRadius: '20px', fontSize: '12px', }}>
                      Learn more
                    </Button>
                  </Box>
                </Stack>
              </Alert>
            }
            <Box sx={{
              width: '100%',
              display: 'flex',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              alignContent: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              //backgroundColor: 'red',
              overflow: 'hidden'
            }}>
              {!showChat && <MapUI authStatus={authStatus} profile={profile} />}

            </Box>
            <MapOverlay authStatus={authStatus ?? ''} profile={profile} />
          </Grid>


        </Grid>
        {(!isDisclaimerCookie && showDisclaimerState && isSuccess && authStatus === 'unauthenticated' && !isLoading) && <Disclaimer />}
        {showProfileState && <ProfileWizard />}
        {/* {(showAuthProfileState) && <AuthProfileDialog open={showAuthProfileState} onClose={() => dispatch(showAuthProfile(false))}/>} */}
        <DataDeletionInstructions />
        <PinInfoModal />
      </>
      </IsMobileContext.Provider>
  );

}

const glassButtonSx = {
  maxWidth: '40px', maxHeight: '40px', minWidth: '40px', minHeight: '40px',
  backgroundColor: 'rgba(244, 240, 255, 0.55)',
  backdropFilter: 'blur(24px)',
  WebkitBackdropFilter: 'blur(24px)',
  border: '1px solid rgba(164, 142, 233, 0.18)',
  boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)',
  '&:hover': { backgroundColor: 'rgba(244, 240, 255, 0.7)' },
};

const ZoomInButton: React.FC = () => {
  const dispatch = useDispatch();
  const zoom = useSelector((state: any) => state.search.zoom);
  return (
    <Button disableElevation variant="contained" sx={glassButtonSx}
      onClick={() => dispatch(setZoom(Math.min(zoom + 1, 21)))}>
      <Add sx={{ color: '#656EFF' }} />
    </Button>
  );
};

const ZoomOutButton: React.FC = () => {
  const dispatch = useDispatch();
  const zoom = useSelector((state: any) => state.search.zoom);
  return (
    <Button disableElevation variant="contained" sx={glassButtonSx}
      onClick={() => dispatch(setZoom(Math.max(zoom - 1, 3)))}>
      <Remove sx={{ color: '#656EFF' }} />
    </Button>
  );
};

const MapUI1: React.FC<{ authStatus: any, profile: any }> = ({ authStatus, profile }) => {
  const searchState = useSelector((state: any) => state.search, (prev, next) => {
    if (!next.status) return true
    if (!next.status.isSuccess) return true
    if (!prev.center) return false
    return prev.formattedSearchTerm === next.formattedSearchTerm //&& ( prev.showProfileDialog === next.showProfileDialog  )
  });

  const [alertOpen, setAlertOpen] = useState(true);

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          padding: 0,
          backgroundColor: 'transparent',
          position: {
            xs: 'fixed',
            sm: 'fixed',
            md: 'absolute',
          },
          zIndex: 1001,
          top: {
            xs: '132px',
            sm: '132px',
            md: '132px',
          },
          right: {
            xs: '10px',
            sm: '10px',
            md: '10px',
          }
        }}
      >
        <Stack direction="column" gap={0}>
          {(authStatus === "authenticated" && profile?.is_completed) && <>
            {profile?.id && <CenterMapHome profileLat={profile.lat} profileLng={profile.lng} id={profile.id} />}
            <Divider sx={{ width: '100%' }} />
            <AddPinChip id="map_add_pin" chipText={'Add my Pin'} />
            <Divider sx={{ width: '100%' }} />
          </>}
          <ZoomInButton />
          <Divider sx={{ width: '100%' }} />
          <ZoomOutButton />
        </Stack>
      </Paper>
      {/* <Box sx={{ backgroundColor: 'lightblue', width: '100%', height: '100%', }}>  <Map authStatus={authStatus} profile={profile} /></Box> */}

      <MapBars id={profile?.id}
        lat={searchState?.center?.lat}
        lng={searchState?.center?.lng}
        profileLat={profile?.lat}
        profileLng={profile?.lng}
        formattedSearchTerm={searchState.formattedSearchTerm}
        zipCode={searchState.zipCode}
        authStatus={authStatus} />
      <MapPinCount />
      <Map1 authStatus={authStatus} profile={profile} />
    </>
  )
}
const Map1 = React.memo(Map);
export const AppBody = React.memo(AppBody1);
const MapUI = React.memo(MapUI1);


function logToBackEnd(arg0: { context: string; message: string; version: string; }) {
  throw new Error("Function not implemented.");
}
//export default App;
